













import { Component, Prop, Mixins } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import ClientMixin from "@/mixins/clientMixin";
@Component
export default class UClientLink extends Mixins(ClientMixin) {
  // Props

  @Prop({ required: false, default: () => ({}) })
  public client!: IClient;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ required: false, default: "adminClient" })
  public to!: string;

  @Prop({ required: false, default: () => ({}) })
  public params!: object;

  @Prop({ default: 0 })
  public truncate!: number;

  // Getters

  public get component() {
    if (this.$_.isEmpty(this.client)) return null;
    return {
      type: "router-link",
      props: {
        to: {
          name: this.to,
          params: {
            ...this.params,
            clientId: this.clientId
          }
        }
      }
    };
  }

  public get fullName() {
    return this.getClientName({
      client: this.client,
      clientId: this.clientId,
      orEmail: true
    }) as string;
  }

  public get truncatedName() {
    const name = this.fullName;
    if (!this.truncate || !name) return name;
    const truncated = name.substr(0, this.truncate);
    if (truncated.length + 1 >= name.length) return name;
    return `${truncated}…`;
  }
}
